import script from "./managementOrders.vue?vue&type=script&setup=true&lang=js"
export * from "./managementOrders.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__